module.exports = __webpack_public_path__ + "img/doc-reject.61f984b7.svg";